const state = {
  isLoginError: false,
  redirectUrl: '',
  loginErrorTips: '',
  isIndia: false,
  isManage: '0',
  isComplete: false,
  isolationCode: ''
}

const mutations = {
  updateState: (state, payload) => {
    Object.keys(payload).forEach((item) => {
      state[item] = payload[item]
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
